import { playersApi } from "@/apis/apis";
import Badge from "@/components/Badge";
import { BannerPreviewModal } from "@/components/BannerEditorModal/BannerPreviewModal";
import ImageWithFallback from "@/components/ImageWithFallback";
import StatusBadge from "@/components/StatusBadge";
import { booleanOptionIconLabels } from "@/constant/GeneralOptions/boolean";
import { DEFAULT_LANGUAGE_LABEL } from "@/constant/Languages/language";
import { formatDateTime } from "@/utils/helper";

export const columns = () => {
  const booleanOptionLabelsMap = booleanOptionIconLabels();

  return [
    {
      accessorKey: "status",
      header: `MPL Status`,
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      id: "show_in_profile",
      accessorFn: (row) => booleanOptionLabelsMap[row.show_in_profile],
      header: "Show Profile?",
      cell: ({ getValue }) => (
        <div className={"flex justify-center"}>{getValue()}</div>
      ),
    },
    {
      accessorKey: "history_status",
      header: `Player History Status (${DEFAULT_LANGUAGE_LABEL})`,
      cell: ({ row }) => (
        <StatusBadge status={row.getValue("history_status")} />
      ),
    },
    {
      accessorKey: "sport_id",
      header: "Sport ID",
      cell: ({ row }) => <div>{row.original.sport?.code}</div>,
    },
    {
      accessorKey: "number_of_active_languages",
      header: `# Active Languages`,
      enableSorting: false,
    },
    {
      id: "default_last_change.date",
      accessorFn: (row) => formatDateTime(row.default_last_change?.date),
      header: `Last Change`,
    },
    {
      accessorKey: "default_last_change.by",
      header: `Last Change By`,
    },
    {
      accessorKey: "code",
      header: "ID",
    },
    {
      accessorKey: "name",
      header: "Player Name",
    },
    {
      accessorKey: "tags",
      header: "Player Name (Tags)",
      cell: ({ row }) => (
        <div className="flex gap-1 capitalize">
          {row.original.tags?.map((tag) => (
            <Badge key={tag.id}> {tag.name}</Badge>
          ))}
        </div>
      ),
    },
    {
      accessorKey: "player_type_id",
      header: "Player Type ID",
      cell: ({ row }) => <div>{row.original.player_type?.code}</div>,
    },
    {
      accessorKey: "birth_city",
      header: "Birth City",
      cell: ({ row }) => <div>{row.original.birth_city_name?.name}</div>,
    },
    {
      accessorKey: "birth_country",
      header: "Birth Country",
      cell: ({ row }) => <div>{row.original.birth_country?.name}</div>,
    },
    {
      accessorKey: "birth_date",
      header: "Birth Date",
    },
    {
      accessorKey: "height",
      header: "Height in cm",
    },

    {
      accessorKey: "nationality_1",
      header: "Nationality 1",
      cell: ({ row }) => <div>{row.original.nationality_1?.name || "-"}</div>,
    },
    {
      accessorKey: "nationality_2",
      header: "Nationality 2",
      cell: ({ row }) => <div>{row.original.nationality_2?.name || "-"}</div>,
    },
    {
      accessorKey: "nationality_3",
      header: "Nationality 3",
      cell: ({ row }) => <div>{row.original.nationality_3?.name || "-"} </div>,
    },

    {
      accessorKey: "is_notable_player",
      header: "Is Notable Player",
      accessorFn: (row) => booleanOptionLabelsMap[row.is_notable_player],
    },
    {
      accessorKey: "is_legend_player",
      header: "Is Legend Player",
      accessorFn: (row) => booleanOptionLabelsMap[row.is_legend_player],
    },
    {
      accessorKey: "banner_file_url",
      header: "Banner",
      cell: ({ row }) =>
        row.original?.banner_file_url && (
          <BannerPreviewModal
            api={playersApi}
            data={row.original}
            image_url={row.original?.banner_file_url}
          />
        ),
      enableResizing: false,
      enableSorting: false,
    },
    {
      accessorKey: "thumbnail_file_url",
      header: "Thumbnail",
      cell: ({ row }) => (
        <ImageWithFallback url={row.getValue("thumbnail_file_url")} />
      ),
      enableResizing: false,
      enableSorting: false,
    },
    {
      accessorKey: "total_likes",
      header: "Likes",
      cell: ({ row }) => <div>{row.original.likes?.total_likes || 0}</div>,
    },
    {
      accessorKey: "total_share",
      header: "Shares",
      cell: ({ row }) => <div>{row.original.shares?.total_shares || 0}</div>,
    },
    {
      accessorKey: "total_views",
      header: "Views",
      cell: ({ row }) => <div>{row.original.views?.total_views || 0}</div>,
    },
  ];
};
